export default [
    {
        label: 'Rotating Proxies',
        value: 0,
    },
    {
        label: 'Sticky',
        value: 1,
    },
]